import React from 'react';
import Text from 'components/Text/Text';
import { Form, Checkbox } from 'antd';

interface IProps {
	toggleApplicableForVat: () => void;
	isApplicableForVat: boolean;
}

export const IsApplicableForVat: React.FC<IProps> = ({ toggleApplicableForVat, isApplicableForVat }) => {
	return (
		<Form.Item name="isApplicableForVat">
			<Checkbox checked={isApplicableForVat} onChange={toggleApplicableForVat}>
				<Text translationNameSpace="form" translationKey="isApplicableForVatLabel" asFragment={true} />
			</Checkbox>
		</Form.Item>
	);
};
